import { connect } from 'react-redux';
import { RootState } from '../../../redux/store';
import {
  sessionViewSelectors,
  setSessionActiveTab,
} from '../../../redux/views/session-view/session/slice';
import { SessionView } from '.';

const mapStateToProps = (state: RootState) => ({
  leftPanelType: sessionViewSelectors.getLeftPanelType(state),
  sessionActiveTab: sessionViewSelectors.getSessionActiveTab(state),
});

const mapDispatchToProps = {
  setSessionActiveTab,
};

export type SessionViewProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

export const SessionViewContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SessionView);
